module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"header":{"published":"Publikováno","definition":"Definice"}},"de":{"header":{"published":"Veröffentlicht","definition":"Definition"}},"es":{"header":{"published":"Publicado","definition":"Definición"}},"fr":{"header":{"published":"Publié","definition":"Définition"}}}')
  delete Component.options._Ctor
}
